import { useEffect } from 'react';

import { usePathname } from 'expo-router';
import { store as routerStore } from 'expo-router/build/global-state/router-store';

import { usePrevious } from 'hooks/use-previous';
import { logPageView } from 'state/amplitude';
import { BranchEventNames } from 'state/branch/branch-event-names';
import { logBranchEvent } from 'state/branch/utils';
import { useStoreContext } from 'state/store';

import { logFirebasePageView } from './log-firebase-page-view';

// Only used for react-router and WEB
export default function useLogPageView() {
  const pathname = usePathname();
  const previousPathname = usePrevious(pathname);
  const { store } = useStoreContext();

  // uncomment to debug router state
  // useDebugLogRouterState();

  useEffect(() => {
    if (previousPathname !== pathname) {
      logPageView(pathname, store);
      logFirebasePageView(pathname);
      logBranchEvent(BranchEventNames.PAGE_VIEW);
      if (__DEV__) {
        // eslint-disable-next-line no-console
        console.log('PATH:', routerStore?.routeInfo?.unstable_globalHref);
      }
    }
  }, [pathname, store, previousPathname]);
}
